import { useDebounce } from "use-debounce";

import { JSX } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

import { IconSadFace } from "@/components/icons";

import { useGetCollections, useGetPersons, useGetSearchContent } from "@/hooks/api/content.hooks";
import { useIsKids } from "@/hooks/useIsKids";

import SearchCollectionsSection from "./sections/SearchCollectionsSection";
import SearchContentSection from "./sections/SearchContentSection";
import SearchPersonsSection from "./sections/SearchPersonsSection";

const SearchPage = (): JSX.Element => {
  const { t } = useTranslation();

  const [params] = useSearchParams();

  const [search] = useDebounce(params.get("search"), 1000);

  const content = useGetSearchContent({ limit: 16, search });
  const persons = useGetPersons(26, search ?? "");
  const collections = useGetCollections(search ?? "");

  const isKids = useIsKids();

  const isEmpty =
    content.data?.pages[0].results.length == 0 &&
    persons.data.pages[0].results.length == 0 &&
    collections.data.length == 0;

  return (
    <div className={"mt-5 rounded-7.5 max-lg:rounded-5 max-sm:mt-16 "}>
      <h1 className={"mb-5 text-[2rem] font-semibold max-xl:text-[1.5rem]  max-lg:mb-3"}>
        {search ? t("Actions.search-result") : t("Actions.usually-search")}
      </h1>
      <SearchContentSection content={content} />
      {!isKids && <SearchPersonsSection persons={persons} />}
      <SearchCollectionsSection collections={collections} />
      {isEmpty && (
        <div className={"flex h-[70vh] flex-col items-center justify-center"}>
          <IconSadFace className="size-44 max-sm:size-36" />
          <div className={"mt-4 max-w-[27.5rem] text-center"}>
            <h1 className={"text-2xl font-semibold"}>{t("error.nothing-found")}</h1>
            <p className={"mt-2 text-lg/6 text-on-surface"}>{t("error.nothing-found-message")}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchPage;
